import wx from 'wx';
import { getLoginUser } from './login';

// const WECHAT_AUTH_KEY="wechat_auth_key";
// const WECHAT_AUTH_VALUE="authing";
const WECHAT_AUTH_EXPIRE_KEY="wechat_auth_key_expire";
const WECHAT_AUTH_REDIRECT="wechat_auth_redirect";
const WECHAT_LOCATION_CODE="wechat_location_code";

export const isLocalServer = () => {
  const origin = window.location.origin;
  return origin.includes('localhost') || origin.startsWith('http://192.168.');
}

export const isWechatAuth = () => {
  const expireStr = window.localStorage.getItem(WECHAT_AUTH_EXPIRE_KEY);
  if (expireStr) {
    const expireAt = Number.parseInt(expireStr) || 0;
    return expireAt >= Date.now();
  } else {
    return false;
  }
  // return window.localStorage.getItem(WECHAT_AUTH_KEY) === WECHAT_AUTH_VALUE;
}

export const setAreaCode = (code) => {
  window.localStorage.setItem(WECHAT_LOCATION_CODE, code);
}

export const getAreaCode = () => {
  return window.localStorage.getItem(WECHAT_LOCATION_CODE);
}

export const setWechatAuth = (redirectHref) => {
  if (isWechatAuth()) return ;
  window.localStorage.setItem(WECHAT_AUTH_EXPIRE_KEY, (Date.now() + 600000) + "");
  // window.localStorage.setItem(WECHAT_AUTH_KEY, WECHAT_AUTH_VALUE);
}

export const setAuthRedirect = (redirectHref) => {
  window.localStorage.setItem(WECHAT_AUTH_REDIRECT, redirectHref);
}

export const getAuthRedirect = () => {
  return window.localStorage.getItem(WECHAT_AUTH_REDIRECT) || '/nav/home';
}

export const clearWechatAuth = () => {
  window.localStorage.removeItem(WECHAT_AUTH_REDIRECT);
  window.localStorage.removeItem(WECHAT_AUTH_EXPIRE_KEY);
  // window.localStorage.removeItem(WECHAT_AUTH_KEY);
}

// 需要在微信执js sdk ready 以后才能执行
export const updateShareInfo = (params) => {
  const { title, desc, link ,imgUrl, success } = params;

  const currentUserInfo = getLoginUser();
  const currentLink = link || window.location.href;
  const fullLink = currentLink +
    (currentLink.includes('?') ? '&' : '?') + "shareMember=" + ( currentUserInfo && currentUserInfo.id ? currentUserInfo.id : '' );

  wx.ready(() => {
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
    wx.updateAppMessageShareData({
      title: title || "幸福课堂",
      desc: desc || "邀请您观看幸福课堂视频",
      link: fullLink,
      imgUrl: imgUrl || window.location.origin + "/logo.png",
      success: () => {
        console.log('share info success');
        if (typeof success === 'function') {
          success();
        }
      },
      fail: () => {
        console.log('fail');
      }
    });

    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
    wx.updateTimelineShareData({
      title: title || "幸福课堂",
      link: fullLink,
      imgUrl:  imgUrl || window.location.origin + "/logo.png",
      success: () => {
        console.log('share info success');
        if (typeof success === 'function') {
          success();
        }
      },
      fail: () => {
        console.log('fail');
      }
    })

  })
}

export const updateWxShareInfo = ({title, desc, link ,imgUrl, successConfig, successCallback}) => {
  wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function (res) {
        // 设置成功
        if (typeof successConfig === 'function') {
          successConfig();
        }
      },
      fail: (res) => {
        window.alert(JSON.stringify(res));
      },
      complete: (res) => {

      },
      trigger: (res) => {

      }
    });

    wx.updateTimelineShareData({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 设置成功
        if (typeof successConfig === 'function') {
          successConfig();
        }
      },
      fail: (res) => {
        window.alert(JSON.stringify(res));
      },
      complete: (res) => {

      },
      trigger: (res) => {

      }
    })
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        if (typeof successCallback === 'function') {
          successCallback();
        }
      },
      fail: (res) => {
        window.alert(JSON.stringify(res));
      },
      complete: (res) => {

      },
      trigger: (res) => {

      }
    });

    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        if (typeof successCallback === 'function') {
          successCallback();
        }
      },
      fail: (res) => {
        window.alert(JSON.stringify(res));
      },
      complete: (res) => {

      },
      trigger: (res) => {

      }
    });

  });
}
